import {ValueObject} from '@s-ui/domain'

export default class UserTakeoutLinkValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.url - Download URL (legacy behavior)
   * @param {Blob} data.blob - Binary blob (Transcend API)
   * */
  constructor(data = {}) {
    super(data)
    // Store blob separately to avoid serialization
    this._blob = data.blob
    this._url = data.url
  }

  /**
   * Get the blob without serializing it
   * @return {Blob|undefined}
   */
  getBlob() {
    return this._blob
  }

  /**
   * Get the URL
   * @return {string|undefined}
   */
  getUrl() {
    return this._url
  }
}
